import React from 'react';
import StarIcon from '../common/StarIcon';
import './SandwichFallbackArt.css';

const SandwichFallbackArt = ({ sandwich, featured = false }) => {
  const label = sandwich.newAddition ? 'New Addition' : 'Star Deli Special';

  return (
    <div
      className={`sandwich-fallback-art ${featured ? 'sandwich-fallback-art-featured' : ''}`}
      role="img"
      aria-label={`${sandwich.name} specialty sandwich illustration`}
    >
      <div className="sandwich-fallback-ticket">
        <span className="sandwich-fallback-label">{label}</span>
        <StarIcon name={sandwich.visualIcon || 'sandwich'} className="sandwich-fallback-icon" />
        <span className="sandwich-fallback-name">{sandwich.name}</span>
      </div>
    </div>
  );
};

export default React.memo(SandwichFallbackArt);
